import { ResourceLanguage } from 'i18next';

const fr: ResourceLanguage = {
    translation: {
        MoreDetails: 'plus de détails',
        Copyright: 'Tous droits réservés - Adam Michaud',
        TechnicalSkills: 'Compétences techniques',
        SkillTiers: {
            Expert: 'Expert',
            Proficient: 'Maîtrisé',
            Familiar: 'Familier',
        },

        Intro: {
            Hello: 'Bonjour, je suis',
            JobTitle: 'Architecte Logiciel & Développeur Full-Stack, M.Ing',
        },

        Contact: {
            ContactMe: 'Contactez-moi',
            Email: 'Courriel',
            Phone: 'Téléphone',
        },

        Navigation: {
            Home: 'Accueil',
            About: 'À propos',
            Skills: 'Compétences',
            Experiences: 'Expériences',
            Projects: 'Projets',
            Contact: 'Contact',
            ChangeLang: 'English',
        },

        AboutMe: {
            Title: 'À propos de moi',
            Infos: "Je suis Adam — architecte logiciel et développeur full-stack basé à Montréal. Depuis plus de 5 ans, je livre des plateformes infonuagiques .NET et Angular de bout en bout : j'ai dirigé la migration d'une application patrimoniale de 160 000 lignes vers Blazor WebAssembly sur Azure, bâti un serveur MCP pour intégrer le développement agentique assisté par IA à notre chaîne de livraison, et défini les standards d'Infrastructure as Code (IaC) et de CI/CD utilisés à l'échelle de l'entreprise. Je pilote l'architecture, encadre les développeurs et transforme des systèmes complexes et critiques en produits propres et maintenables.",
        },

        Interests: {
            Title: "Mes champs d'intérêt",
            Programming: {
                Title: 'Architecture infonuagique',
                Infos: "Concevoir des systèmes infonuagiques évolutifs et des cadres partagés qui aident les équipes à livrer plus vite et les entreprises à atteindre leurs objectifs numériques.",
            },
            ArtificialIntelligence: {
                Title: 'IA & développement agentique',
                Infos: "Je bâtis des outils assistés par IA et agentiques — comme des serveurs MCP — qui relient les applications aux modèles de langage et font avancer des problèmes complexes.",
            },
            VideoGames: {
                Title: 'Excellence en ingénierie',
                Infos: "De l'architecture propre et de la conception SOLID jusqu'au CI/CD et à l'Infrastructure as Code, je bâtis des systèmes qui restent maintenables et fiables à grande échelle.",
            },
        },

        Education: {
            Title: ' Éducation',
            Master: {
                Degree: 'M.Ing Génie Informatique',
                School: 'Polytechnique Montréal',
            },

            Bachelor: {
                Degree: 'B.Sc. Informatique',
                School: 'Université de Montréal',
                Scholarship: "Bourse d'Excellence des Diplômés et Professeurs du DIRO",
                Mention: "Mentions d'excellence académique",
            },

            College: {
                Degree: 'DEC Sciences Informatiques et Mathématiques',
                School: 'Collège Lionel-Groulx',
                RScore: 'Cote R',
            },
        },

        WorkExperiences: {
            Title: ' Expérience de travail',
            NormandinBeaudry: {
                Title: 'Développeur Full-Stack Senior / Architecte Logiciel',
                Dates: 'Novembre 2024 - Aujourd\'hui',
                Dept: 'Innovation & Architecture',
                Tasks: {
                    Task1: "Diriger les initiatives d'architecture à l'échelle de l'entreprise en bâtissant des cadres partagés Blazor et API .NET (architecture propre) livrés comme paquets NuGet, permettant aux équipes de se concentrer sur les fonctionnalités.",
                    Task2: "Concevoir un serveur MCP (Model Context Protocol) reliant nos applications aux modèles de langage IA, et adopter le développement agentique assisté par IA pour accélérer la livraison.",
                    Task3: "Planifier et diriger la migration d'une application patrimoniale WinForms de 160 000 lignes — une plateforme financière rendant compte de milliards de dollars d'actifs investis — vers Blazor WebAssembly sur Azure avec un backend API .NET.",
                    Task4: "Standardiser l'infrastructure et la livraison avec l'Infrastructure as Code (IaC) basée sur Terraform et des gabarits CI/CD réutilisables dans Azure DevOps.",
                    Task5: "Implémenter l'authentification Entra ID en migrant la plateforme d'authentification interne hors d'IdentityServer 4.",
                },
            },
            CDPQ: {
                Title: 'Stagiaire développeur',
                Dates: 'Janvier 2021 - Avril 2021',
                Dept: 'Expérience numérique',
                Tasks: {
                    Task1: 'Concevoir et développer des plateformes numériques libre-service efficientes.',
                    Task2: "Développer des interfaces utilisateurs réactives dans le but d'améliorer l'expérience des utilisateurs.",
                    Task3: "Développer et configurer des systèmes de collecte de données et des tableaux de bord basés sur la technologie Google Analytics, en collaborant au sein d'une équipe agile multidisciplinaire.",
                },
            },
            JovacoProgrammer: {
                Title: 'Programmeur-Analyste',
                Dates: 'Mai 2021 - Janvier 2024',
                Dept: 'Solutions infonuagiques',
                Tasks: {
                    Task1: 'Concevoir et architecturer des applications web modernes déployées sur le cloud.',
                    Task2: "Maintenir une grande application patrimoniale au service de plus de 200 entreprises clientes, comptant chacune jusqu'à des milliers d'utilisateurs.",
                    Task3: 'Développer des applications web full-stack, principalement avec Angular et C#.',
                    Task4: "Concevoir sur Figma des interfaces axées sur l'utilisabilité afin d'améliorer l'expérience utilisateur.",
                    Task5: "Automatiser les pipelines CI/CD dans Azure DevOps, accélérant la livraison et détectant les régressions avant la mise en production.",
                },
            },
            JovacoTechLead: {
                Title: 'Lead Technique Cloud / Architecte',
                Dates: 'Janvier 2024 - Novembre 2024',
                Dept: 'Solutions infonuagiques',
                Tasks: {
                    Task1: "Encadrer une équipe de développeurs par des révisions de code et du pair programming, rehaussant la qualité globale du code.",
                    Task2: "Introduire de meilleures méthodes de travail, comme la décomposition structurée des exigences.",
                    Task3: 'Définir et valider les exigences techniques des nouvelles fonctionnalités.',
                    Task4: "Piloter le développement du produit de bout en bout — écrire du code, créer des tests automatisés et établir des normes de codage.",
                    Task5: "Suivre les technologies infonuagiques émergentes et partager des recommandations concrètes avec l'équipe.",
                },
            },
        },

        Projects: {
            Title: 'Projet récent',
            Featured: {
                Tag: 'Tech for Good',
                Name: 'Unitas Humanitas',
                Subname: 'Plateforme OBNL · Bénévole',
                Infos: "J'ai conçu et développé — bénévolement — la plateforme bilingue (FR/EN) complète d'Unitas Humanitas, un OBNL québécois qui redonne la dignité et bâtit l'espoir pour des enfants et des familles vulnérables. Un frontal React appuyé par un CMS headless PayloadCMS (Next.js), déployé sur Azure (Static Web Apps, Container Apps, Azure DNS, Communication Services) avec de l'infrastructure en tant que code Terraform et des pipelines CI/CD GitHub Actions.",
            },
        },

        WorkTogether: {
            Title: 'Travaillons ensemble',
            Infos: "Êtes-vous à la recherche du candidat parfait pour votre prochain projet ambitieux ? Je suis toujours motivé à relever les défis et à participer à la création de nouvelles idées numériques. N'hésitez pas à me contacter pour discuter de la manière dont je peux vous aider à transformer votre idée en réalité.",
        },

        Location: {
            City: 'Montréal',
            Province: 'Québec',
        },
    },
};

export default fr;
